// extracted by mini-css-extract-plugin
module.exports = {"wrap":"am-z"};